import { render } from "./DashboardAntragErstellenModalCreate.pug?vue&type=template&id=2e64cdbe&lang=pug"
import script from "./DashboardAntragErstellenModalCreate.js?vue&type=script&lang=js"
export * from "./DashboardAntragErstellenModalCreate.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__